import { withGenericConfig } from "/contexts/generic-config-context";
import { componentStyles } from "./paragraph-with-demo-component.scss";

const ParagraphWithDemoComponent = ({
  title,
  description,
  translate,
  icon: Icon,
  demoComponent: DemoComponent,
  demoComponentMetadata,
  templateData,
  templateDataFieldName
}) => {
  const shouldHideComponent = () => {
    return templateDataFieldName && !templateData[templateDataFieldName];
  };

  return shouldHideComponent() ? null : (
    <div className="paragraph-with-demo">
      <div className="paragraph-content-wrapper">
        <h2 className="paragraph-content-title">{title}</h2>
        <div className="paragraph-content-description-wrapper">
          {Icon && (
            <div className="paragraph-content-icon">
              <Icon />
            </div>
          )}
          <div className="paragraph-content-description">{description}</div>
        </div>
      </div>
      {DemoComponent && (
        <div className="paragraph-demo-wrapper">
          <DemoComponent translate={translate} metadata={demoComponentMetadata} templateData={templateData} />
        </div>
      )}
      <style jsx>{componentStyles}</style>
    </div>
  );
};

export default withGenericConfig(ParagraphWithDemoComponent);
